import React from "react";
import { useTranslation } from "react-i18next";

export default function Footer() {
    const { t } = useTranslation();
    return (
        <footer className="flex w-full flex-col items-center space-y-4 mb-[50px] mt-[32px] pt-[32px] px-6">
            <div className="md:w-1/2 w-full border-t-[8px] border-[#3A57FF] self-start"></div>
            <div className="flex w-full text-[#494949] text-base font-normal leading-6 space-x-0 md:space-x-[253px] justify-between md:justify-start">
                <button onClick={() => window.location.href = '/copyright'}>
                    {t("footer.copyright")}
                </button>
                <button onClick={() => window.location.href = '/contact'}>
                    {t("footer.contactUs")}
                </button>
            </div>
            <div className="flex w-full text-[#494949] text-base font-normal leading-6 space-x-[253px]">
                <button onClick={() => window.location.href = '/privacypolicy'}>
                    {t("footer.privacyPolicy")}
                </button>
            </div>
            <div className="flex w-full text-[#494949] text-base font-normal leading-6 space-x-[253px]">
                <button onClick={() => window.location.href = '/terms'}>
                    {t("footer.termsOfService")}
                </button>
            </div>
            <div className="mx-auto flex space-x-[16px] md:pt-[0px] pt-[64px] text-center">
                {t("footer.copyrightNotice")}
            </div>
        </footer>
    );
}
